import { h } from 'preact';
import { Header } from '@cube/blocks';
import cx from 'classnames';
import { Text } from 'preact-i18n';
import Footnotes from '../footnotes';
import StockDetails from '../stock-details';
import style from './style';

const INTL_NS = 'statistics-panel';

const FOOTNOTES = [
	'marketCapSecurityStats',
	'trailingPe',
	'enterpriseValueRevenue',
	'enterpriseValueEbitda',
	'fiscalYearEnds',
	'mostRecentQuarter',
	'revenuePerShare',
	'quarterlyRevenueGrowth',
	'quarterlyEarningsGross',
	'totalCashPerShare',
	'totalDebtEquity',
	'currentRatio',
	'bookValuePerShare',
	'payoutRatio'
].map((name) => ({
	name,
	text: <Text id={`${INTL_NS}.${name}`} />,
	break: name === 'quarterlyEarningsGross'
}));

export default function StatisticsDesktop({ quote, width, ...props }) {
	return (
		<div>
			<div class={cx(style.statistics, width > 600 && style.wide)}>
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.valuationMeasures`} />} />
				<StockDetails
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'marketCapSecurityStats',
						'enterpriseValue',
						'trailingPe',
						'priceToSale',
						'priceToBook',
						'enterpriseValueRevenue',
						'enterpriseValueEbitda'
					]}
				/>
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.financialHighlights`} />} />
				<StockDetails
					header={<Text id={`${INTL_NS}.fiscalYear`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'fiscalYearEnds',
						'mostRecentQuarter'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.profitability`} />}
					quote={quote}
					fields={[
						'profitMargin',
						'operatingMargin'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.managementEffectiveness`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'returnOnAssets',
						'returnOnEquity'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.incomeStatement`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'revenue',
						'revenuePerShare',
						'quarterlyRevenueGrowth',
						'grossProfit',
						'ebitda',
						'dilutedEps',
						'quarterlyEarningsGross'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.balanceSheet`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'totalCash',
						'totalCashPerShare',
						'totalDebt',
						'totalDebtEquity',
						'currentRatio',
						'bookValuePerShare'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.cashFlowStatement`} />}
					quote={quote}
					fields={[
						'operatingCashFlow',
						'leveredFreeCashFlow'
					]}
				/>
			</div>
			<div class={cx(style.statistics)}>
				<Header class={style.statisticsHeader} title={<Text id={`${INTL_NS}.tradingInformation`} />} />
				<StockDetails
					header={<Text id={`${INTL_NS}.stockPriceHistory`} />}
					quote={quote}
					fields={[
						'oneYearChange',
						'oneYearHigh',
						'oneYearLow',
						'oneWeekAvgVolume',
						'threeMonthAvgVolume',
						'sharesOutstanding'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.oneWeekPerformance`} />}
					quote={quote}
					fields={[
						'vsDowWeek',
						'vsSPWeek',
						'vsNasdaqWeek'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.oneYearPerformance`} />}
					quote={quote}
					fields={[
						'vsDowYear',
						'vsSPYear',
						'vsNasdaqYear'
					]}
				/>
				<StockDetails
					header={<Text id={`${INTL_NS}.dividendInformation`} />}
					quote={quote}
					footnotes={FOOTNOTES}
					fields={[
						'trailingDividendRate',
						'trailingDividendYield',
						'payoutRatio'
					]}
				/>
			</div>
			<Footnotes notes={FOOTNOTES} />
		</div>
	);
}
